import dayjs from 'dayjs-ext'

const locale = {
  name: 'ru',
  weekdays: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
  weekdaysShort: 'вск_пнд_втр_срд_чтв_птн_сбт'.split('_'),
  weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
  months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
  monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
  formats: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY г.',
    LLL: 'D MMMM YYYY г., H:mm',
    LLLL: 'dddd, D MMMM YYYY г., H:mm'
  },
  relativeTime: {
    // Using 3 plural forms for 1 and x1, 2-4 and x2-4, 5-
    duration: {
      s: 'несколько секунд',
      m: 'минута',
      mm: ['%d минута', '%d минуты', '%d минут'],
      h: 'час',
      hh: ['%d час', '%d часа', '%d часов'],
      d: 'день',
      dd: ['%d день', '%d дня', '%d дней'],
      M: 'месяц',
      MM: ['%d месяц', '%d месяца', '%d месяцев'],
      y: 'год',
      yy: ['%d год', '%d года', '%d лет']
    },
    future: {
      s: 'через несколько секунд',
      m: 'через минуту',
      mm: ['через %d минуту', 'через %d минуты', 'через %d минут'],
      h: 'через час',
      hh: ['через %d час', 'через %d часа', 'через %d часов'],
      d: 'завтра',
      dd: ['через %d день', 'через %d дня', 'через %d дней'],
      M: 'через месяц',
      MM: ['через %d месяц', 'через %d месяца', 'через %d месяцев'],
      y: 'через год',
      yy: ['через %d год', 'через %d года', 'через %d лет']
    },
    past: {
      s: 'несколько секунд назад',
      m: 'минуту назад',
      mm: ['%d минуту назад', '%d минуты назад', '%d минут назад'],
      h: 'час назад',
      hh: ['%d час назад', '%d часа назад', '%d часов назад'],
      d: 'вчера',
      dd: ['%d день назад', '%d дня назад', '%d дней назад'],
      M: 'месяц назад',
      MM: ['%d месяц назад', '%d месяца назад', '%d месяцев назад'],
      y: 'в прошлом году',
      yy: ['%d год назад', '%d года назад', '%d лет назад']
    }
  },
  ordinal: n => n
}

dayjs.locale(locale, null, true)

export default locale
